import angular from 'angular';
import BoxPostByCategoryComponent from './box-post-by-category.component';

let BoxPostByCategoryModule = angular.module('catalog.productsModules.boxPostByCategory', [])
  .component('boxPostByCategory', BoxPostByCategoryComponent);

export default BoxPostByCategoryModule;


/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/category/box-post-by-category/box-post-by-category.js
 **/